import { FC } from 'react';
import { Chip } from '@mui/material';

interface PaymentBadgeProps {
    label: string;
}

const PaymentBadge: FC<PaymentBadgeProps> = ({ label }) => {
    return <Chip variant="outlined" color="primary" size="small" label={label} />;
};
export default PaymentBadge;
